<template>
  <div class="content">
    <div class="set_flexwrap">
      <div class="flex_wrap">
        <el-form ref="form" :rules="rules" :model="formdata" label-width="120px">
          <el-form-item label="商城名称" prop="name">
            <el-input v-model="formdata.name" placeholder="请输入商城名称"></el-input>
          </el-form-item>
          <el-form-item label="商城轮播图" v-if="decorate==1">
            <!-- <div class="cooperation-body" v-if="formdata.pic.length">
              <draggable v-model="formdata.pic" :options="{draggable:'.draggableItem',animation: 150}" 
                         @update="datadragEnd" class="draggable-body-list">
                <transition-group class="draggable-body">
                  <div v-for="(item,index) in formdata.pic" :key="item" class="draggableItem" :draggable="draggable"
                       :style="{backgroundImage:'url('+item+')',backgroundSize:'cover',backgroundPosition:'center'}"
                       :class="currentindex==index?'activedraggable':''" @click.stop="indexLine(index)">
                    <i class="el-icon-circle-close" @click.stop="closePic(index)"></i>
                  </div>
                </transition-group>
              </draggable>
            </div>
            <div>
              <div class="img_body" @click="showCropper">
                <p class="img_up_text">点击上传</p>
              </div>
              <p class="prompInfo">尺寸为690*367，大小不超过2M</p>
            </div>
            <div class="addicon">
              <div class="el-upload el-upload--text" @click="showCropper">
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </div>
              <div class="el-upload__tip">尺寸为690*367，大小不超过2M</div>
            </div>      -->
          </el-form-item>
       
          <el-table :data="formdata.pic" style="width: 60%">
            <el-table-column prop="pic" label="图片">
              <template slot-scope="scope">
                <img :src="scope.row.pic" alt="" srcset="">
              </template>
            </el-table-column>
            <el-table-column prop="goods_number" label="选择的商品ID"></el-table-column>
            <el-table-column prop="title" label="选择的商品名称"></el-table-column>
            <el-table-column prop="url" label="是否显示">
              <template slot-scope="scope">
                <div>{{scope.row.status == 1? '是':'否'}}</div>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button @click="edit(scope)" type="text" size="small">编辑</el-button>
                <el-button @click="del(scope)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-form-item label="商城轮播图" v-if="decorate==2">
            <div>
              <img :src="formdata.pic2" alt="" width="300">
            </div>
            <!-- <div>
              <div class="img_body" @click="showCropper">
                <p class="img_up_text">点击上传</p>
              </div>
              <p class="prompInfo">尺寸为750*220，大小不超过2M</p>
            </div> -->
            <div class="addicon">
              <div class="el-upload el-upload--text" @click="showCropper">
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </div>
              <div class="el-upload__tip">尺寸为750*220，大小不超过2M</div>
            </div>             
          </el-form-item>
          <div style="margin-top: 20rpx!important;">
            <el-form-item >
              <el-button type="primary" @click="addclassify" size="small">添加</el-button>
              <el-button type="primary" @click="save('form')" size="small">保存</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <!-- <div class="preview_wrap" v-if="decorate==1">
        <div class="mb-20">示例预览</div>
        <div class="preview_wrap_new">
          <img src="/static/img/checkmodule/top01.jpg" alt="" class="module-box-top">
          <div class="preview_wrap_new_body lin-bottom">
            <div class="preview_wrap_new_body-top">
              <div class="preview_wrap_new_body-top-r"><img src="/static/img/checkmodule/bg02.png" alt=""></div>
              <div class="preview_wrap_new_body-top-l">
                <p class="preview_wrap_new_body-top-l-title">{{formdata.name?formdata.name:'商城名称'}}</p>
                <p class="preview_wrap_new_body-top-l-ponint">
                  <span class="point-box-line">评价9.7分</span>
                  <span class="point-box-line-last">发货很快</span>
                  <span class="point-box-line-last">款式新颖</span></p>
              </div>
            </div>
            <div class="preview_wrap_new_body-bottom">
              公告: 2019年春节休假从2020年1月20日至1月29日
            </div>
          </div>
          <div class="bannerbody-module">
            <div class="shop-module-banner"
                 :style="{backgroundImage:'url('+formdata.pic[0].pic+')',backgroundSize:'cover',backgroundPosition:'center'}"
                 v-if="formdata.pic.length">
              <p>1/{{formdata.pic.length}}</p>
            </div>
          </div>
          <img src="/static/img/checkmodule/top03.jpg" alt="" class="module-box-bottpm">
        </div>
      </div>
      <div class="preview_wrap" v-if="decorate==2">
        <div class="mb-20">示例预览</div>
        <div class="preview_wrap_new">
          <img src="/static/img/checkmodule/top01.jpg" alt="" class="module-box-top">
          <div class="preview_wrap_new_body"
               :style="{backgroundImage:'url('+formdata.pic2+')',backgroundSize:'cover',backgroundPosition:'center'}">
            <div class="preview_wrap_new_body-top">
              <div class="preview_wrap_new_body-top-l">
                <p class="preview_wrap_new_body-top-l-title">{{formdata.name?formdata.name:'商城名称'}}</p>
                <p class="preview_wrap_new_body-top-l-ponint">
                  <span class="point-box-line">评价9.7分</span>
                  <span class="point-box-line-last">发货很快</span>
                  <span class="point-box-line-last">款式新颖</span></p>
              </div>
              <div class="preview_wrap_new_body-top-r"><img src="/static/img/checkmodule/bg02.png" alt=""></div>
            </div>
            <div class="preview_wrap_new_body-bottom">
              公告: 2019年春节休假从2020年1月20日至1月29日
            </div>
          </div>
          <img src="/static/img/checkmodule/top02.jpg" alt="" class="module-box-bottpm">
        </div>
      </div> -->

    </div>
    <corpper :visible.sync="corppervisible"
             v-if="corppervisible" @imgAddBack="imgAddBack" :imgSize="imgSize"></corpper>

      <imgClassifyDialog
      :type="type"
      :classifyitem="classifyitem"
      :visible.sync="classifydialog"
      v-if="classifydialog"
      @classifysuccess="classifysuccess"
    ></imgClassifyDialog>
  </div>
</template>
<script>
import imgClassifyDialog from "@/components/dialog/imgClassifyDialog.vue";
  import api from "@/api.js";
  import draggable from 'vuedraggable';
  import corpper from "@/components/dialog/corpper.vue";

  export default {
    name: "basicSettings",
    components: {
      draggable,
      corpper,
      imgClassifyDialog
    },
    data() {
      return {
        pic2: '/static/img/checkmodule/bg03.jpg',
        corppervisible: false,
        imgSize: '',
        formdata: {
          name: "",
          pic:""
        },
        rules: {
          name: [{required: true, message: "请输入商城名称", trigger: "blur"}]
        },
        defultPic: this.defultImg,
        currentindex: '',
        uploadStatus: 'defult', // defult 默认 choose 选中
        draggable: true,
        decorate: '',
        classifydialog: false
      };
    },
    created() {
      this.queryconfig();
    },
    methods: {
       // 添加分类
      addclassify() {
        this.type = "add";
        this.classifydialog = true;
      },
      // 删除
      del(scope) {
        let self_ = this
        let index = scope.$index
        this.$confirm('是否删除该图片?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          showClose: false,
          closeOnClickModal: false
        }).then(() => {
          self_.formdata.pic.splice(index,1)
        }).catch(() => {
        });
      },
       // 编辑
      edit(scope) {
        this.type = "edit";
        this.editIndex = scope.$index;
        this.classifyitem = scope.row;
        this.classifydialog = true;
      },
      // 查询配置
      queryconfig() {
        let params = {};
        this.axios
            .post(api.shopconf_index, params)
            .then(response => {
              if (response.data.code == 0) {
                this.formdata.name = response.data.info.name;
                this.decorate = response.data.info.decorate;
                // formdata: {
                //   name: "",
                //       pic: []
                // },
                if(response.data.info.decorate===1){
                  this.formdata.pic = response.data.info.pic;
                  this.imgSize = 3
                }else{
                  this.formdata.pic2 = response.data.info.pic2;
                  this.imgSize = 4
                }
              } else {
              }
            })
            .catch(response => {
            });
      },
      handleSuccess(res, file) {
        if (res.code === 0) {
          // this.formdata.pic = res.path;
          // uploadStatus: 'defult', // defult 默认 choose 选中
          if (this.uploadStatus === 'defult') {
            this.formdata.pic.push(res.path)
          } else {
            this.$set(this.formdata.pic, this.currentindex, res.path) //这样就能被vue监控到，更新视图
          }
          this.defultPic = res.path;
        }
      },
      beforeUpload(file) {
        const isJPG = file.type === "image/jpeg" || file.type === "image/png";
        const isLt2M = file.size / 1024 / 1024 < 10;
        if (!isJPG) {
          this.$message.error("上传图片只能是 JPG或者PNG 格式!");
        }
        if (!isLt2M) {
          this.$message.error("上传图片大小不能超过 10MB!");
        }
        return isJPG && isLt2M;
      },
      save(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            if(this.decorate===1){
              // this.formdata.pic.push(option)
            }else{
              delete this.formdata.pic
            }
            this.submitsave();
          } else {
            return false;
          }
        });
      },
      imgAddBack(option) {
        if(this.decorate===1){
          this.formdata.pic.push(option)
        }else{
          this.formdata.pic2 = option
        }
      },
      showCropper() {
        this.corppervisible = true
      },
       // 分类回调
      classifysuccess(e) {
        console.log('2323',e)
        if(this.type == 'add'){
          if(this.formdata.pic && this.formdata.pic.length > 0){
            this.formdata.pic.push(e)
          }else{
            this.formdata.pic = [e]
          }
          this.classifydialog = false;
        }else{
          let index = this.editIndex
          let pic = this.formdata.pic
          pic[index] = e
          this.formdata.pic = pic
          // this.$set(e,'formdata.pic',index) 
          console.log(this.formdata)
          this.classifydialog = false;
        }
        return
        this.init();
      },
      // 保存
      submitsave() {
        this.axios
            .post(api.shopconf_conf_edit, this.formdata)
            .then(response => {
              if (response.data.code == 0) {
                this.$message({
                  message: "保存成功",
                  type: "success"
                });
              } else {
              }
            })
            .catch(response => {
            });
      },
      datadragEnd(evt) {
        this.currentindex = evt.newIndex
      },
      closePic(index) {
        // uploadStatus: 'defult', // defult 默认 choose 选中
        this.formdata.pic.splice(index, 1)
      },
      indexLine(index) {
        this.currentindex = index
        this.defultPic = this.formdata.pic[index]
        // uploadStatus: 'defult', // defult 默认 choose 选中
        this.uploadStatus = 'choose'
      }
    }
  };
</script>

<style scoped>
.set_flexwrap {-webkit-box-shadow: none; box-shadow: none;}
</style>